import React, { useState, useEffect } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { ScheduledServices } from '../../dados/services';

export default function HistoricoServicos() {
  const [currentPage, setCurrentPage] = useState(1);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const itemsPerPage = 3;

  // Filtra serviços passados (antes da data atual)
  const pastServices = ScheduledServices
    .filter(service => {
      // Para demonstração usamos apenas serviços de Abril antes do dia 12
      return service.date.includes('Abril') && parseInt(service.date.split(' ')[0]) < 12;
    })
    // Ordena os serviços por data (do mais antigo para o mais recente - ordem cronológica)
    .sort((a, b) => {
      const dateA = parseInt(a.date.split(' ')[0]); // Extrai o dia da data
      const dateB = parseInt(b.date.split(' ')[0]); // Extrai o dia da data
      return dateA - dateB; // Ordem crescente (mais antigo primeiro - ordem cronológica)
    });

  // Cálculo para paginação
  const totalPages = Math.ceil(pastServices.length / itemsPerPage);

  // Efeito para atualizar os itens exibidos quando a página muda
  useEffect(() => {
    const loadItems = async () => {
      // Simula uma pequena carga para garantir a limpeza visual
      setIsLoading(true);
      
      // Limpa os itens atuais
      setDisplayedItems([]);
      
      // Pequeno delay para dar o efeito visual de remoção dos itens anteriores
      await new Promise(resolve => setTimeout(resolve, 150));
      
      // Calcula os novos itens
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const newItems = pastServices.slice(indexOfFirstItem, indexOfLastItem);
      
      // Define os novos itens
      setDisplayedItems(newItems);
      setIsLoading(false);
    };
    
    loadItems();
  }, [currentPage]);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Função para traduzir o status
  const translateStatus = (status) => {
    switch (status) {
      case 'upcoming':
        return 'Realizado';
      case 'scheduled':
        return 'Realizado';
      default:
        return 'Realizado';
    }
  };

  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto py-8 px-4 flex flex-col justify-between">
        <h1 className="text-3xl font-bold text-green-800 mb-6">Histórico de Serviços</h1>
        
        {pastServices.length === 0 ? (
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <p className="text-lg text-gray-600">Nenhum serviço passado encontrado.</p>
          </div>
        ) : (
          <>
            <div className="grid gap-5 mb-6">
              {isLoading ? (
                <div className="col-span-full text-center py-8">
                  <p className="text-green-600">Carregando...</p>
                </div>
              ) : (
                displayedItems.map((service) => (
                  <div 
                    key={service.id} 
                    className="bg-white rounded-lg shadow-md p-4 border-l-4 border-green-500 hover:shadow-lg transition-shadow"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <div className="flex items-center">
                        <div className="h-10 w-10 rounded-full bg-green-50 flex items-center justify-center mr-4">
                          {service.icon}
                        </div>
                        <div>
                          <h3 className="font-semibold text-green-900">{service.service}</h3>
                          <p className="text-sm text-gray-600">{service.date} • {service.day}</p>
                        </div>
                      </div>
                      <div>
                        <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800 border border-green-200">
                          {translateStatus(service.status)}
                        </span>
                      </div>
                    </div>
                    
                    <div className="mt-4 flex items-center justify-between">
                      <div className="text-sm text-gray-600">
                        <span className="font-medium">Horário:</span> {service.time}
                      </div>
                      <div className="flex space-x-2">
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            
            {/* Paginação (só mostra se tiver mais de uma página) */}
            {totalPages > 1 && (
              <div className="flex justify-between items-center">
                <button 
                  onClick={prevPage} 
                  disabled={currentPage === 1 || isLoading}
                  className={`flex items-center px-4 py-2 rounded-md ${
                    currentPage === 1 || isLoading ? 'text-gray-400 cursor-not-allowed' : 'text-green-600 hover:bg-green-100'
                  }`}
                >
                  <ArrowLeft size={16} className="mr-1" /> Anterior
                </button>
                
                <div className="text-sm text-green-800">
                  Página {currentPage} de {totalPages}
                </div>
                
                <button 
                  onClick={nextPage} 
                  disabled={currentPage === totalPages || isLoading}
                  className={`flex items-center px-4 py-2 rounded-md ${
                    currentPage === totalPages || isLoading ? 'text-gray-400 cursor-not-allowed' : 'text-green-600 hover:bg-green-100'
                  }`}
                >
                  Próximo <ArrowRight size={16} className="ml-1" />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}